import React from 'react';
import { ParticipantsQuickActionsProps } from './ParticipantsQuickActionsTypes';
import { Box, Button, Tooltip } from '@mui/material';

const ParticipantsQuickActions = ({
  onAddEmpty,
  onAddFromApplicant,
  disabledFromApplicant,
  maxReached,
  showAddFromApplicant = true,
}: ParticipantsQuickActionsProps) => {
  return (
    <Box display="flex" gap={2} mb={2}>
      <Button variant="outlined" onClick={onAddEmpty} disabled={!!maxReached}>
        Dodaj pustego uczestnika
      </Button>
      {showAddFromApplicant && (
        <Tooltip title="Kliknij, aby szybko dodać uczestnika z danymi zgłaszającego">
          <span>
            <Button
              variant="contained"
              color="primary"
              onClick={onAddFromApplicant}
              disabled={disabledFromApplicant || maxReached}
            >
              Dodaj uczestnika z danymi zgłaszającego
            </Button>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};

export default ParticipantsQuickActions;
